interface InterestStarsProps {
  level: number;
}

export default function InterestStars({ level }: InterestStarsProps) {
  return (
    <>
      {Array(5)
        .fill(0)
        .map((_, index) => (
          <span
            key={index}
            className={index < level ? "text-yellow-400" : "text-gray-300"}
          >
            ★
          </span>
        ))}
    </>
  );
}
